import CryptoJS from "crypto-js";

export const encodeData = (data) => {
    const queryData = data;
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(queryData),process.env.REACT_APP_SECRET_KEY).toString();
    const encodedQuery = encodeURIComponent(encryptedData);
    return encodedQuery;
  };
export const findModuleById = (modules, header_id) => {
    for (const module of modules) {
      if (module.header_id === header_id) {
        return module;
      }
      
      if (module.sub_module) {
        const found = findModuleById(module.sub_module, header_id);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };
export const findModuleByRoute = (modules, path) => {
    // console.log("modules",modules);
    for (const module of modules) {
        // console.log("module.path",module.path);
      if (module.path === path) {
        return module;
      }
      
      if (module.sub_module) {
        const found = findModuleByRoute(module.sub_module, path);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };
export const decodeUrl = (encodedData) => {
    let decodedData = {};
     try {
        const decryptedBytes = CryptoJS.AES.decrypt(
            decodeURIComponent(encodedData),
            process.env.REACT_APP_SECRET_KEY
        );
        decodedData = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
        // console.log("decodedData 1",parseInt(decodedData));
        return decodedData;
        // console.log("decodedData 2",decodedData);
        } catch (error) {
        console.error("Error decrypting query params", error);
        }
    return null;
  };
export const decodeData = (encodedData,permissions) => {
    let decodedData = {};
     try {
        const decryptedBytes = CryptoJS.AES.decrypt(
            decodeURIComponent(encodedData),
            process.env.REACT_APP_SECRET_KEY
        );
        decodedData = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
        // console.log("decodedData 1",parseInt(decodedData));
        // console.info("permissions",permissions);
        // console.log("findModuleById",findModuleById(permissions,decodedData));
        decodedData= findModuleById(permissions,decodedData);
        decodedData= JSON.parse(decodedData?.header_permissions);

        return decodedData;
        // console.log("decodedData 2",decodedData);
        } catch (error) {
        console.error("Error decrypting query params", error);
        }
    return null;
  };

export const abstartOldUrl = "https://abs.abstarthr.com/";

export const bloodGroupOptions = [
  { value: "A+", label: "A+" },
  { value: "A-", label: "A-" },
  { value: "B+", label: "B+" },
  { value: "B-", label: "B-" },
  { value: "AB+", label: "AB+" },
  { value: "AB-", label: "AB-" },
  { value: "O+", label: "O+" },
  { value: "O-", label: "O-" },
];
export const genderOptions = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: 'Other', label: 'Other' },
];
export const titleOptions = [
  { value: 'Mr.', label: 'Mr.' },
  { value: 'Mrs.', label: 'Mrs.' },
  { value: 'Ms.', label: 'Ms.' },
];
export const emergencyContactPerson = [
  { value: 'Brother', label: 'Brother' },
  { value: 'Sister', label: 'Sister' },
  { value: 'Mom', label: 'Mom' },
  { value: 'Dad', label: 'Dad' },
  { value: 'Cousin', label: 'Cousin' },
];

export const monthData = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const masterCheatCode=[
    {
        name:"Current Date",
        code:"##current_date##"
    },
    {
        name:"Offer Letter Link",
        code:"##offer_letter_link##"
    },
    {
        name:"Appointment Letter Link",
        code:"##appointment_letter_link##"
    },
    {
        name:"Employee Panel Link",
        code:"##employee_panel_url##"
    },
    {
        name:"Data Collection Link",
        code:"##data_collection_link##"
    },
    {
        name:"User Credentials",
        code:"##user_credentials##"
    },
    {
        name:"Company Name",
        code:"##company_name##"
    },
    {
        name:"Employee Code",
        code:"##employee_code##"
    },
    {
        name:"Employee Name",
        code:"##employee_name##"
    },
    {
        name:"Employee Address",
        code:"##employee_address##"
    },
    {
        name:"Department Title",
        code:"##department_title##"
    },
    {
        name:"Designation Title",
        code:"##designation_title##"
    },
    {
        name:"Grade Title",
        code:"##grade_title##"
    },
    {
        name:"Location Title",
        code:"##location_title##"
    },
    {
        name:"Employee Joining Date",
        code:"##employee_joining_date##"
    },
    {
        name:"Salary Amount",
        code:"##salary_amount##"
    },
    {
        name:"CTC Structure",
        code:"##ctc_structure##"
    },
    {
        name:"Signatory",
        code:"##signature_image##"
    },
];
export const formatDateAndTime = (dateTimeString, format12Hour) => {
    const date = new Date(dateTimeString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');

    if (format12Hour === 12) {
        const ampm = hours >= 12 ? 'PM' : 'AM';
        // Convert hours from 24-hour to 12-hour format
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        hours = String(hours).padStart(2, '0');
        return `${day}-${monthData[parseInt(month)]}-${year}T${hours}:${minutes} ${ampm}`;
    } else {
        hours = String(hours).padStart(2, '0');
        return `${day}-${monthData[parseInt(month)]}-${year}T${hours}:${minutes}`;
    }
};

export const tableFormatDateAndTime = (dateTimeString, format12Hour) => {
    let dateAndTime;
    if (format12Hour === 12) {
        dateAndTime = formatDateAndTime(dateTimeString, 12);
    }
    else{
        dateAndTime = formatDateAndTime(dateTimeString);
    }
    return `${dateAndTime?.split("T")[0]}, ${dateAndTime?.split("T")[1]}`
}

export const currentDateAndTime = (isT) => {
    // Options to format time in 24-hour format
    let options = { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' };
    let formattedTime = new Date().toLocaleTimeString(undefined, options);
    
    // Get local date in YYYY-MM-DD format
    let localDate = new Date();
    let formattedDate = localDate.toISOString().split("T")[0]; // This gets the date in local timezone
    
    let dateTime;
    if (isT === "T") {
        dateTime = `${formattedDate}T${formattedTime}`; // T format (YYYY-MM-DDTHH:mm:ss)
    } else {
        dateTime = `${formattedDate} ${formattedTime}`; // Space format (YYYY-MM-DD HH:mm:ss)
    }

    return dateTime;
};

export function formatDateTimeLog(dateTimeString) {
    // Parse input date while preserving local time
    let parsedDate = dateTimeString.includes("T")
        ? new Date(dateTimeString)
        : new Date(dateTimeString.replace(" ", "T"));

    if (isNaN(parsedDate)) return "Invalid date";

    // Get current local date and time using currentDateAndTime function
    const nowString = currentDateAndTime("T"); 
    console.log(nowString);
    const now = new Date(nowString);
    console.log(now);
    // Convert parsedDate to local time for accurate comparison
    parsedDate = new Date(parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000);

    // Get the time difference in minutes
    const timeDiffMs = now.getTime() - parsedDate.getTime();
    const timeDiffMin = Math.floor(timeDiffMs / 60000);

    // Check if the input date is today
    const isToday = parsedDate.toDateString() === now.toDateString();

    if (isToday) {
        const hours = Math.floor(timeDiffMin / 60);
        const minutes = timeDiffMin % 60;
        return hours > 0 ? `Today, ${hours}h ${minutes}min ago` : `Today, ${minutes}min ago`;
    }

    // Format for past dates
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const month = monthNames[parsedDate.getMonth()];
    const day = parsedDate.getDate();
    const year = parsedDate.getFullYear();
    let hours = parsedDate.getHours();
    let minutes = parsedDate.getMinutes().toString().padStart(2, "0");

    // Function to add suffix to day (st, nd, rd, th)
    const suffix = (day) => {
        if (day >= 11 && day <= 13) return "th";
        switch (day % 10) {
            case 1: return "st";
            case 2: return "nd";
            case 3: return "rd";
            default: return "th";
        }
    };

    // Convert to 12-hour format with AM/PM
    const period = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;

    return `${month} ${day}${suffix(day)}, ${year} ${formattedHours}:${minutes} ${period}`;
}

export function getFirstDateBeforeTwoMonths(currentDate) {
    // Create a new Date object from the current date
    const date = new Date(currentDate);
    
    // Subtract 2 months
    date.setMonth(date.getMonth() - 4);
    
    // Set the date to the 1st of the month
    date.setDate(1);
    
    // Format the date as 'YYYY-MM-DD'
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
}

export function getTotalDaysBetweenDates(fromDate, toDate) {
    try {
        const start = new Date(fromDate);
        const end = new Date(toDate);

        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
            return 0;
        }

        const timeDiff = end - start;
        const dayDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)); // ms → days

        return dayDiff >= 0 ? dayDiff : 0;
    } catch (error) {
        return 0;
    }
}

export function getDateAfterToday(days) {
    if (!days || isNaN(days)) return "";

    const today = new Date();
    today.setDate(today.getDate() + days);

    return today.toISOString().split("T")[0]; // Format: 'YYYY-MM-DD'
}

export function getDateBeforeToday(days) {
    if (!days || isNaN(days)) return "";

    const today = new Date();
    today.setDate(today.getDate() - days);

    return today.toISOString().split("T")[0]; // Format: 'YYYY-MM-DD'
}

export function getPreviousDate(inputDate) {
    // Create a new Date object from the input date
    const date = new Date(inputDate);
    
    // Subtract one day (in milliseconds) from the date
    date?.setDate(date.getDate() - 1);
    
    // Format the date as 'yyyy-mm-dd' (optional)
    const previousDate = date?.toISOString().split('T')[0];
    
    return previousDate || "";
}

export function getCurrentCycleStartDate(currentDate, cycleDay) {
    const date = new Date(currentDate);
    const year = date.getFullYear();
    const month = date.getMonth();

    // Determine if the current date is before or after the cycle day in the current month
    const currentCycleStart = new Date(year, month, cycleDay);

    // If the current date is before the cycle day, return the start date of the previous month
    if (date < currentCycleStart) {
        const prevMonth = new Date(year, month - 1, cycleDay);
        return prevMonth;
    }

    // Otherwise, return the start date of the current month
    return currentCycleStart;
}

export function getFullYearMonthArray(currentDate) {
    // Convert to Date object if currentDate is not already a Date object
    if (!(currentDate instanceof Date)) {
        currentDate = new Date(currentDate);
    }

    const months = [
        'January', 'February', 'March', 'April', 'May', 'June', 
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    
    const year = currentDate.getFullYear();
    const result = months.map((month, index) => ({
        // value: `${index + 1}-${year}`,
        value: index + 1,
        label: `${month} ${year}`
    }));
    
    return result;
}

export function getDaysDifference(date) {
    const date1 = new Date(date);
    const date2 = currentDateAndTime("T");
    const timeDifference = date2.getTime() - date1.getTime();
    const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
    return daysDifference;
}
export function formatDateWithTime(isDate) {
    // let options = { hour12: true, hour: '2-digit', minute: '2-digit' };
    let date=new Date(isDate);
    if(!isDate){
        date = new Date();
    }
     // This uses the user's device date and time

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const day = date.getDate().toString().padStart(2, '0');
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;

    // Time options for HH:MM AM/PM format
    const timeOptions = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    };

    const time = date.toLocaleTimeString(undefined, timeOptions); // Using undefined to use user's locale

    return `${formattedDate} ${time}`;
}
export function formatDateToSQL(inputDate) {
    const date = new Date(inputDate); // Convert the string to a Date object

    const padZero = (num) => (num < 10 ? '0' + num : num);

    const year = date.getFullYear();
    const month = padZero(date.getMonth() + 1); // Months are 0-based
    const day = padZero(date.getDate());
    const hours = padZero(date.getHours());
    const minutes = padZero(date.getMinutes());
    const seconds = padZero(date.getSeconds());

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export const getMonthCycleStartDate=(currentDate, startDay)=> {
    const currDate = new Date(currentDate); // Convert currentDate to Date object
    const currYear = currDate.getFullYear();
    const currMonth = currDate.getMonth();  // 0-based index for months
    // If the current date's day is less than the start day, subtract one month
    let monthCycleStart = new Date(currYear, currDate.getDate() >= startDay ? currMonth : currMonth - 1, startDay);
    return monthCycleStart.toISOString().split('T')[0]; // Return in 'YYYY-MM-DD' format
}

export const getNextMonthIfDayExceeds20=(date)=> {
    const inputDate = new Date(date); // Convert input to Date object
    let year = inputDate.getFullYear();
    let month = inputDate.getMonth() + 1; // getMonth() returns 0-based index, so add 1 for proper month

    // Check if the day of the month is more than 20
    if (inputDate.getDate() > 20) {
        month += 1; // Move to the next month
        if (month > 12) {
            month = 1; // If month is greater than 12, wrap around to January
            year += 1; // Increment the year
        }
    }

    // Format the month to always be two digits (e.g., '09' instead of '9')
    const formattedMonth = month < 10 ? `0${month}` : month;

    return `${formattedMonth}-${year}`;
}

export function validateDateFormat(date) {
    // Regular expressions for both formats
    const ddMmYyyyPattern = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/;
    const yyyyMmDdPattern = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;

    let day, month, year;

    // Check the format and extract parts
    if (ddMmYyyyPattern.test(date)) {
        [day, month, year] = date.split('-').map(Number);
    } else if (yyyyMmDdPattern.test(date)) {
        [year, month, day] = date.split('-').map(Number);
    } else {
        return { isValid: false, message: "Invalid date format. Expected DD-MM-YYYY or YYYY-MM-DD." };
    }

    // Step 1: Validate the year
    if (year.toString().length !== 4) {
        return { isValid: false, message: "Invalid year. The year must be 4 digits long." };
    }
    if (year < 1000) {
        return { isValid: false, message: `Invalid year.` };
    }

    // Step 2: Validate the month
    if (month < 1 || month > 12) {
        return { isValid: false, message: "Invalid month. The month must be between 01 and 12." };
    }

    // Step 3: Validate the day
    const daysInMonth = new Date(year, month, 0).getDate(); // Get days in the given month/year
    if (day < 1 || day > daysInMonth) {
        return { isValid: false, message: `Invalid day. The day must be between 01 and ${daysInMonth} for the given month.` };
    }

    // If all checks pass
    return { isValid: true, message: "The date is valid." };
}


// export function decryptData(encryptedData) {
//     if (!encryptedData || !encryptedData.includes('.')) {
//         throw new Error('Invalid encrypted data format. Expected "ivBase64.encryptedBase64".');
//     }

//     const [ivBase64, encryptedBase64] = encryptedData.split('.');
//     const iv = CryptoJS.enc.Base64.parse(ivBase64);
//     const encrypted = CryptoJS.enc.Base64.parse(encryptedBase64);
//     const secretKey = process.env.REACT_APP_ENCEYPTION_SECRET;

//     if (!secretKey) {
//         throw new Error('Encryption secret key is not defined. Check REACT_APP_ENCEYPTION_SECRET.');
//     }

//     console.log("Secret Key:", secretKey);
//     console.log("IV (Base64):", ivBase64);
//     console.log("Encrypted Data (Base64):", encryptedBase64);

//     try {
//         const decrypted = CryptoJS.AES.decrypt(
//             { ciphertext: encrypted },
//             CryptoJS.enc.Utf8.parse(secretKey), // Ensure the key is correctly parsed
//             {
//                 iv: iv,
//                 mode: CryptoJS.mode.CBC,
//                 padding: CryptoJS.pad.Pkcs7
//             }
//         );

//         if (!decrypted || decrypted.sigBytes <= 0) {
//             throw new Error('Decryption failed. Result is empty or invalid.');
//         }

//         const decryptedString = CryptoJS.enc.Utf8.stringify(decrypted);

//         if (!decryptedString) {
//             throw new Error('Decrypted string is empty. Verify secret key and input data.');
//         }

//         console.log("Decrypted String:", decryptedString);
//         return decryptedString;
//     } catch (error) {
//         console.error('Decryption error:', error.message);
//         throw new Error('Failed to decrypt data. Ensure inputs and configurations are correct.');
//     }
// }


export function parseQueryString(queryString) {
    const params = {};
    queryString.split('&').forEach(param => {
        const [key, value] = param.split('=');
        params[key] = value;
    });
    return params;
}

export const checkImageLink= (src)=>{
    if (!src) {
        return false;
    }

    try {
        const img = new Image();
        img.src = src;
        img.onload = () => { return true; };
        img.onerror = () => { return false; };
        return false;
    } catch (error) {
        return false;
    }
}

export const checkPDFLink = async (url) => {
    if (!url) return false;

    try {
        const response = await fetch(url, { method: "HEAD" });
        return response.ok && response.headers.get("content-type")?.includes("pdf");
    } catch (error) {
        return false;
    }
};

export const filterModules = (modules) => {
    let result = [];
  
    const traverse = (items) => {
      for (const item of items) {
        result.push({ value: item.header_id, label: item.name });
  
        if (item.sub_module && item.sub_module.length > 0) {
          traverse(item.sub_module);
        }
      }
    };
  
    traverse(modules);
    return result;
  };
